export default __webpack_public_path__ + "assets/images/613c7a2c623b5f9a1a46ef6c4ce7df95.svg";